export default "__VITE_PUBLIC_ASSET__9e144350__"